import { FC } from 'react';

import classes from './Heading1.module.css';

const Heading1: FC = ({ children }) => {
  return <div className={classes.root}>{children}</div>;
};

export default Heading1;
